/**
 * App-wide constants.
 *
 * APP_NAME is replaced by the CLI at project creation time.
 * To change it later, update the value here — it propagates everywhere.
 *
 * Pricing constants (CREDIT_PACKS, SUBSCRIPTION_PLAN) are re-exported from
 * @rocketships/types so they're shared with the API.
 *
 * @context CONTEXT:ENGINEERING:FRONTEND
 */
export const APP_NAME = 'Rocketships'

export { CREDIT_PACKS, SUBSCRIPTION_PLAN } from '@rocketships/types'
